import React, {Component} from 'react';
import AuctionItem from '../HeaderAuctionItem';
import {ListContainer, FoldMoreContainer, FoldMoreTitleComtainer, FoldTitleText, FoldBtn} from './style';
import {DividerLine} from '../AuctionItem/style';
import {observer} from "mobx-react";
import {InfiniteLoader} from '@jdcfe/yep-react';
import noDataImg from '../../../assets/image/no_data.png';
import unit_institution from "../../../store/asset_institution/unit_institution";
import { isElementInViewport, BUSINESS_INFO, getUrlParms, MpingClick} from '../../../utils/tool'

@observer
class HeaderAuctionList extends Component {
  // 倒计时执行函数对象

  constructor(props) {
    super(props);
    this.state = {
      collapseListHasMoreInit: this.props.collapseListHasMore,
      hasMoreInitUsed: false,
      collapseListHasMore: false,
      collapsePageNo: 2
    }
    this.timer = null;
    this.visibilityChangeHandle = this.visibilityChangeHandle.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.hasMoreInitUsed) {
      this.setState({
        collapseListHasMoreInit: nextProps.collapseListHasMore
      })
    }
  }

  componentDidMount() {
    const lastpage = getUrlParms("lastpage") || ''
    const {headerAuctionList} = this.props.store;
    if(this.props.collapseListHasMore) {
      MpingClick("MAuction_PublicAuctionList_SeeMoreExpo",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${headerAuctionList.length}}`)
    }
    // 统一定时器
    this.countdown()
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.timer = setInterval(() => {
      this.countdown();
    }, 1000);
    document.addEventListener('visibilitychange', this.visibilityChangeHandle);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    document.removeEventListener('visibilitychange', this.visibilityChangeHandle);
  }

  visibilityChangeHandle() {
    if (document.visibilityState === 'visible') {
      this.updateRealtimeDataInViewPort()
    }
  }

  updateRealtimeDataInViewPort() {
    const {
      getRealTimeDataByPaimaiIds
    } = this.props.store
    const items = document.querySelectorAll('.auction-item')
    const paimaiIds = []
    if (items) {
      for (let i = 0; i < items.length; i++) {
        if (isElementInViewport(items[i])) {
          paimaiIds.push(items[i].getAttribute('data-paimaiid'))
        }
      }
    }
    if (paimaiIds.length) {
      getRealTimeDataByPaimaiIds(paimaiIds)
    }
  }

  countdown() {
    const {isLoadNext} = this.props
    if(isLoadNext===false){
      return
    }
    const {
      auctionList,
      realTimeData,
      saveCurrData,
      getRealTimeDataByPaimaiIds
    } = this.props.store
    let paimaiIds = []
    auctionList.forEach(item => {
      if (realTimeData[item.id]) {
        const {
          auctionStatus,
          remainTime,
        } = realTimeData[item.id]
        if (auctionStatus !== 2) {
          if (remainTime <= 0) {
            paimaiIds.push(item.id);
          } else {
            realTimeData[item.id].remainTime = remainTime - 1000
          }
        }
      }
    })
    saveCurrData('realTimeData', realTimeData)
    
    if (paimaiIds && paimaiIds.length) {
      getRealTimeDataByPaimaiIds(paimaiIds)
    }
  }

  onScroll = (e) => {

  };

  loadMore = () => {
    
  };

  onCheck = (index) => {
    const lastpage = getUrlParms("lastpage") || ''
    MpingClick("MAuction_PublicAuctionList_SeeMore",false,false, 'MAuction_PublicAuctionList',`{lastpage:${lastpage},position:${index}}`)
    const {
      collapsePageNo
    } = this.state
    // 原需要再店铺页隐藏的拍卖ID，现在不需要隐藏了，故传空
    const excludeCollapsePaimaiId = getUrlParms("excludeCollapsePaimaiId")
    // const excludeCollapsePaimaiId = ''
    const {getCollapseHeaderAuctionList} = unit_institution;
    this.setState({
      hasMoreInitUsed: true
    })
    getCollapseHeaderAuctionList({collapseSrcPaimaiId: excludeCollapsePaimaiId, page: collapsePageNo}, index).then(res => {
      if (res) {
        if ((collapsePageNo == Math.ceil(res.totalItem/30)) || (collapsePageNo > Math.ceil(res.totalItem/30))) {
          this.setState({
            collapseListHasMore: false
          })
        }else {
          this.setState({
            collapseListHasMore: true
          })
        }
        let collapsePageNoLast = parseInt(collapsePageNo);
        collapsePageNoLast += 1;
        this.setState({
          collapsePageNo: collapsePageNoLast.toString()
        })
      }else {
        this.setState({
          collapseListHasMore: false
        })
      }
    })
  }

  isShowAuctionList=()=>{
    let bool = false
    const {curTabIndex, publishSource} = unit_institution
    if (publishSource == BUSINESS_INFO.ZICHAN.code || publishSource == BUSINESS_INFO.POCHAN.code || publishSource == BUSINESS_INFO.HAIGUANANDZF.code) {
      if(curTabIndex===1){
        bool = true
      }
    }else {
      if(curTabIndex===0){
        bool = true
      }
    }
    return bool
  }

  render() {
    const {headerAuctionList, realTimeData} = this.props.store;
    const collapseListHasMore = !this.state.hasMoreInitUsed ? this.state.collapseListHasMoreInit : this.state.collapseListHasMore
    return (
      <div>
        {this.isShowAuctionList() &&
        <ListContainer style={{ paddingBottom: '0.2rem' }}>
          {headerAuctionList && headerAuctionList.length !== 0 && (<InfiniteLoader
            dataLength={headerAuctionList.length}
            onScroll={(e) => {
              this.onScroll(e);
            }}
            loadMore={() => {
              this.loadMore();
            }}
          >
            {headerAuctionList.length !== 0 && headerAuctionList.map(
              (value,index) => (<AuctionItem
                index={index}
                key={value.id}
                itemInfo={value}
                realTimeData={realTimeData[value.id]}
              ></AuctionItem>))
            }
          </InfiniteLoader>)}
          {collapseListHasMore && !!headerAuctionList.length && <FoldMoreContainer>
            <FoldMoreTitleComtainer>
              <FoldTitleText>继续查看同类型拍品 </FoldTitleText>
            </FoldMoreTitleComtainer>
            <FoldBtn onClick={()=>{this.onCheck(headerAuctionList.length)}}>展开</FoldBtn>
          </FoldMoreContainer>}
          {
            !collapseListHasMore && <DividerLine><span>下方为该机构其他拍品</span></DividerLine>
          }
        </ListContainer>
        }
      </div>
    )
  }
}

export default HeaderAuctionList;
